"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cardGridStyle = theme => ({
    borderRadius: '10px',
    padding: '10px',
    boxShadow: '1px 2px 8px 0px #006D901A',
    backgroundColor: theme === 'light' ? '#FFFFFF' : '#272936',
});
const gridStyle = {
    height: '100%'
};
const footerStyle = {
    textAlign: 'right',
    marginTop: '10px'
};
const colorBrand = color => ({
    width: 22,
    height: 22,
    borderRadius: 4,
    background: color,
    marginRight: 10,
    border: color !== 'White' ? 'none' : '2px solid #A1A1A1'
});
exports.default = {
    cardGridStyle,
    gridStyle,
    footerStyle,
    colorBrand
};
